export default {
    1: {
        tr: `<p style="font-weight:600; margin-bottom:0.5rem">
    Sart-Salihli Maden İşletmesi: Türkiye'nin İlk %100 Türk Sermayeli Altın
    Üretim Tesisi
</p>
<p>
    Pomza Export A.Ş. olarak sürdürülebilir madencilik anlayışımızı en ileri
    seviyeye taşıdığımız Sart-Salihli Maden İşletmesi, dünya çapında nadir
    bulunan plaser maden örneklerinden biridir. Türkiye'nin ilk %100 Türk
    sermayesi ile altın üreten firması olarak, madencilik sektöründe tarihi bir
    dönüm noktasına imza atmaktayız.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">Kimyasal Kullanmadan Çevreci Üretim</p>
<p>
    Sart-Salihli Maden İşletmesi'nde, çevre dostu madencilik anlayışının en
    ileri örneklerinden birini sunuyoruz. Altın üretim sürecimiz, doğaya zarar
    verebilecek herhangi bir kimyasal içermeyen yöntemlerle yürütülmektedir.
    Kullanılan sallanan masalar ve yerçekimi yöntemi, en saf haliyle altını elde
    etmeye olanak tanırken, doğanın dengesini koruma ilkemizi desteklemektedir.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">
    %99 Su Geri Dönüşümü ile Kaynakları Koruyoruz
</p>
<p>
    Madencilikte su tüketimi büyük bir öneme sahiptir. Sart-Salihli tesisimizde
    kullanılan suyun %99'unu arıtarak yeniden üretime kazandırıyor, böylece su
    kaynaklarımızın korunmasını sağlıyoruz. Bu sayede minimum su tüketimi ile
    maksimum verimlilik prensibi doğrultusunda çalışarak çevre üzerindeki
    etkilerimizi azaltıyoruz.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">
    Türkiye’de Elektrikli Kamyon Kullanmaya Başlayan 2. Firma
</p>
<p>
    Madencilik sektöründe sürdürülebilirlik denildiğinde sadece üretim
    süreçlerini değil, lojistik ve taşıma süreçlerini de çevre dostu hale
    getirmeyi hedefliyoruz. Bu kapsamda, Sart-Salihli sahamızda elektrikli
    kamyonlar kullanmaya başlayan Türkiye’deki ikinci firma olmaktan gurur
    duyuyoruz. Elektrikli kamyonlarımız sayesinde karbon salınımını en aza
    indiriyor, yakıt tüketimini azaltıyor ve doğaya verdiğimiz zararı minimuma
    indiriyoruz.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">
    Türkiye'de İlk Garnet ve Rutil Üretimini Gerçekleştiren Firma
</p>
<p>
    Sart-Salihli Maden İşletmesi, yalnızca altın üretimi ile değil, aynı zamanda
    Türkiye’de ilk Garnet ve Rutil üreten firma olmasıyla da öne çıkmaktadır. Bu
    iki önemli endüstriyel mineral, boya, seramik sanayi, su jeti, kumlama ve
    ileri teknoloji sektörleri olmak üzere birçok alanda kullanılmaktadır.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">Üretilen Mineraller ve Kullanım Alanları</p>
<p>
    Sart-Salihli Maden İşletmesi'nde altın dışında garnet, kuvars, rutil,
    agrega, korund ve silis kumu gibi değerli mineraller üretilmektedir:
</p>
<ul style="margin-top:1rem; margin-bottom:0.5rem;">
    <li>
        <strong>Altın:</strong> Kuyumculuk, yatırım aracı ve ileri teknoloji
        uygulamalarında kullanılır.
    </li>
    <li>
        <strong>Garnet:</strong> Su jeti kesiminde, aşındırıcı kumlama
        işlemlerinde ve filtreleme sistemlerinde kullanılır.
    </li>
    <li>
        <strong>Kuvars:</strong> Cam sanayinde, seramik üretiminde ve elektronik
        bileşenlerde kullanılır.
    </li>
    <li>
        <strong>Rutil:</strong> Titanyum dioksit pigmenti üretiminde, seramik ve
        boya sanayinde değerlendirilir.
    </li>
    <li>
        <strong>Agrega:</strong> İnşaat sektöründe beton ve asfalt üretiminde
        önemli bir malzemedir.
    </li>
    <li>
        <strong>Korund:</strong> Aşındırıcı malzeme üretimi, seramik ve optik
        sektöründe kullanılır.
    </li>
    <li>
        <strong>Silis Kumu:</strong> Cam üretiminde, filtreleme sistemlerinde ve
        döküm sanayinde tercih edilir.
    </li>
</ul>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">
    Sürdürülebilirlik ve Teknolojiyle Geleceğe Yatırım
</p>
<p>
    Pomza Export olarak madencilik sektöründe çevre dostu üretim yöntemleri ve
    en son teknolojileri kullanarakfaaliyetlerimizi yürütüyoruz. Sart-Salihli
    Maden İşletmesi, bu anlayışımızın en somut örneklerinden biridir.
</p>

<ul style="margin-top:1rem; margin-bottom:0.5rem; list-style-type: disc; list-style-position: inside">
    <li>Türkiye'nin ilk %100 Türk sermayeli altın üretim firması</li>
    <li>Türkiye'de ilk Hematit ve Rutil üretimini gerçekleştiren firma</li>
    <li>Kimyasal içermeyen altın üretimi</li>
    <li>%99 su geri dönüşüm sistemi</li>
    <li>Elektrikli kamyon kullanımında öncü firma</li>
</ul>

<p>
    olması ile sektörde fark yaratıyor, doğaya ve insana duyarlı bir
    madencilik anlayışını hayata geçiriyoruz. Sart-Salihli Maden İşletmesi,
    yalnızca bugünün değil, geleceğin de madencilik modeli olarak örnek teşkil
    etmektedir.
</p>

<p style="margin-top:1rem">
    Pomza Export olarak sürdürülebilir ve çevreci madencilik
    faaliyetlerimizi daha da ileriye taşımak için çalışmaya devam ediyoruz.
</p>`,
        en: `<p style="font-weight:600; margin-bottom:0.5rem">
    Sart-Salihli Mining Operation: Turkey's First 100% Turkish Capital Gold Production Facility
</p>
<p>
    At Pomza Export A.Ş., we have taken our commitment to sustainable mining to the highest level with Sart-Salihli Mining Operation, one of the rare placer mining examples in the world. As Turkey's first company to produce gold with 100% Turkish capital, we have marked a historic milestone in the mining industry.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">Environmentally Friendly Production Without Chemicals</p>
<p>
    At Sart-Salihli Mining Operation, we showcase one of the most advanced examples of environmentally friendly mining. Our gold production process is carried out using chemical-free methods that do not harm nature. Shaking tables and gravity separation allow us to obtain the purest gold while supporting our principle of preserving nature’s balance.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">
    99% Water Recycling to Preserve Resources
</p>
<p>
    Water consumption is a significant concern in mining. At our Sart-Salihli facility, we purify and reuse 99% of the waterused in production, ensuring the conservation of water resources. By working with minimal water consumption and maximum efficiency, we reduce our environmental impact.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">
    The 2nd Company in Turkey to Use Electric Trucks
</p>
<p>
    When it comes to sustainability in mining, we aim to make not only our production processes but also our logistics and transportation operations environmentally friendly. In this regard, we are proud to be the second company in Turkey to use electric trucks at our Sart-Salihli site. With electric trucks, we minimize carbon emissions, reduce fuel consumption, and lower our environmental impact.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">
    The First Company in Turkey to Produce Garnet and Rutile
</p>
<p>
    The Sart-Salihli Mining Operation stands out not only for its gold production but also as the first company in Turkey to produce Garnet and Rutile. These two important industrial minerals are used in many areas such as paint, ceramics industry, water jets, sandblasting, and high-tech sectors.
</p>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">Minerals Produced and Their Applications</p>
<p>
    In addition to gold, Sart-Salihli Mining Operation produces valuable minerals such as garnet, quartz, rutile, aggregate, corundum, and silica sand:
</p>
<ul style="margin-top:1rem; margin-bottom:0.5rem;">
    <li>
        <strong>Gold:</strong> Used in jewelry, as an investment asset, and in high-tech applications.
    </li>
    <li>
        <strong>Garnet:</strong> Applied in water jet cutting, abrasive blasting, and filtration systems.
    </li>
    <li>
        <strong>Quartz:</strong> Used in the glass industry, ceramic production, and electronic components.
    </li>
    <li>
        <strong>Rutile:</strong> Used in titanium dioxide pigment production, ceramics, and the paint industry.
    </li>
    <li>
        <strong>Aggregates:</strong> A crucial material for the construction industry, including concrete and asphalt production.

    </li>
    <li>
        <strong>Emery:</strong> Used in abrasive materials, ceramics, and optical industries..
    </li>
    <li>
        <strong>Silica Sand:</strong> Preferred in glass production, filtration systems, and the foundry industry.
    </li>
</ul>
<p style="font-weight:600; margin-top:1rem; margin-bottom:0.5rem">
    Investing in Sustainability and Technology for the Future
</p>
<p>
    At Pomza Export, we conduct our operations using environmentally friendly production methods and the latest technologies in the mining industry. Sart-Salihli Mining Operation is a prime example of this commitment.
</p>

<ul style="margin-top:1rem; margin-bottom:0.5rem; list-style-type: disc; list-style-position: inside">
    <li>Turkey's first 100% Turkish capital gold production company</li>
    <li>The first company in Turkey to produce Garnet and Rutile</li>
    <li>Chemical-free gold production</li>
    <li>99% water recycling system</li>
    <li>A pioneer in electric truck usage</li>
</ul>

<p>
    We are making a difference in the industry by implementing a mining approach that is respectful to nature and humanity. Sart-Salihli Mining Operation is not only the model of today’s mining industry but also the mining model of the future.
</p>

<p style="margin-top:1rem">
    At Pomza Export, we continue to push the boundaries of sustainable and eco-friendly mining practices.
</p>`,
    },
    2: {
        tr: `
            <p style="margin-bottom:1rem;">
                Türkiye’de Tarım Perliti konusunda öncü olan Eti Maden İşletmelerinin İzmir Yeniköy Perlit Maden Sahasını şirketimiz POMZA Export Madencilik San. Ve Tic. A.Ş. devir almıştır. Perlit konusunda 1969 yılından günümüze kesintisiz çalışmaları devam eden şirketimiz sahip olduğu tecrübe ve bilgi ile konu sahada yenilikçi ve endüstriyel işletmecilik yapmaktadır.
            </p>
            <p style="margin-bottom:1rem;">
                Hatırı sayılır büyüklük, kalite ve rezerve sahip sahamızda şirketimiz gereken planlamaları yaparak modernizasyon yatırımlarını başlatmış ve 2019 yılında ETİPER markalı perlit ürünlerini müşterilerine sunmaya başlamıştır. Şirketimizin başlatmış olduğu yatırımlar, farklı sektörlerin ihtiyaçlarını karşılayacak yenilikçi çözümler üretme hedefiyle kesintisiz olarak devam etmektedir.
            </p>
            <p style="margin-bottom:1rem;">
                Tarım, İnşaat, Döküm, Gıda, Filtrasyon, Boya sanayileri başta olmak üzere, perlitin kullanıldığı her alanda müşteri ihtiyaçlarına uygun kalite ve kalibrasyonda üretim yapmaktayız. Ayrıca müşteri ihtiyaçlarına uygun ambalajda ürün tedariği sağlamaktayız.
            </p>
            <p style="margin-bottom:1rem;">
                Sahamızda bulunan GES (Güneş Enerjisi Santrali) ile elde edilen enerji sayesinde, perlit ürünlerimiz çevre dostu ve sürdürülebilirlik esasına göre üretilmekte ve hem yurtiçi hem de yurtdışı pazarlara sunulmaktadır.
            </p>
            <p style="margin-bottom:1rem;">
                Yeniköy perlit madeni sahamızda, 2 farklı işletmemiz daha bulunmaktadır. Pomex Blok tesisi ve Eile Pomex Yapı Kimyasalları fabrikası, perlit katklılı çeşitli uç ürünler üreterek Türk ekonomisine katma değer yaratmaktadır.
            </p>
            <p style="margin-bottom:1rem;">
                2 adet robotik üretim hattının bulunduğu Pomex Blok tesisimiz, genleşmiş perlit katkılı blok üretimi yapmaktadır. Çevreci üretimin benimsendiği, ileri teknoloji ile çalışan blok tesisimizin üretim kapasitesi sektör talebiyle beraber her yıl artmaktadır.
            </p>
            <p style="margin-bottom:1rem;">
                Eile Pomex Yapı Kimyasalları fabrikasında, Pomza Export’un ürettiği madenler kullanılarak yenilikçi inşaat malzemeleri üretilmektedir. Otomatik üretim ve dolum sistemlerinin kullanıldığı ileri teknoloji üretim tesisimizde, perlit katkılı yalıtım sıvası, su izolasyon sistemleri, onarım güçlendirme ve zemin sistemleri gibi 150’den fazla ürün üretilmektedir.
            </p>
            `,
        en: `
            <p style="margin-bottom:1rem;">
                Our company, POMZA Export Mining Industry and Trade Inc., has taken over the İzmir Yeniköy Perlite Mine Site from Eti Maden Enterprises, a pioneer in the field of agricultural perlite in Turkey. Our company has been continuously working on perlite since 1969 and, with its extensive experience and knowledge, carries out innovative and industrial mining operations at the site.
            </p>
            <p style="margin-bottom:1rem;">
                With a significant reserve, high quality, and substantial size, our site has undergone careful planning, and modernization investments have been initiated. In 2019, we began offering ETİPER-branded perlite products to our customers. These investments continue uninterruptedly with the goal of developing innovative solutions to meet the needs of various industries.
            </p>
            <p style="margin-bottom:1rem;">
                We produce perlite in the required quality and calibration tailored to customer needs across all fields where perlite is used, especially in agriculture, construction, foundry, food, filtration, and paint industries. Additionally, we provide products in packaging customized to customer requirements.
            </p>
            <p style="margin-bottom:1rem;">
                Through to the Solar Power Plant (SPP) located at our site, our perlite products are produced based on environmental and sustainability principles and are offered to both domestic and international markets.
            </p>
            <p style="margin-bottom:1rem;">
                At our Yeniköy Perlite Mine Site, we also operate two additional facilities: the Pomex Block Plant and the Eile Pomex Construction Chemicals Factory, both of which create value for the Turkish economy by producing various end products with perlite additives.
            </p>
            <p style="margin-bottom:1rem;">
                Our Pomex Block Plant, equipped with two robotic production lines, produces expanded perlite block products. Adopting eco-friendly production and using advanced technology, the plant’s production capacity increases every year in line with sector demand.
            </p>
            <p style="margin-bottom:1rem;">
                At the Eile Pomex Construction Chemicals Factory, innovative construction materials are produced using minerals extracted by Pomza Export Mining. In our state-of-the-art production facility, which features automatic production and filling systems, more than 150 different products are manufactured—including perlite-based thermal insulation plasters, waterproofing systems, repair and reinforcement materials, and flooring systems.
            </p>
            `,
    },
};
